<template>
  <div class="d-flex justify-content-between mb-3">
    <h2 class="fw-light d-flex align-items-center mb-0">
      Acesso aos Documentos
    </h2>
    <div>
      <router-link
        v-if="isManager"
        to="/reports/manager-pendences"
        class="btn btn-success rounded-pill"
        :class="{
          'btn-danger': pendencesManager > 0,
        }"
        title="Aprovações Pendentes (Gestor)"
      >
        <span v-if="isLoadingPendencesManager">
          <i class="ph-spinner spinner me-2" />
          Buscando Aprovações Pendentes (Gestor)
        </span>
        <span v-else>
          Aprovações Pendentes (Gestor)
          <span v-if="pendencesManager > 0" class="badge bg-primary ms-2">
            {{ pendencesManager }}
          </span>
        </span>
      </router-link>
      <router-link
        v-if="isFinancialManager"
        to="/reports/financial-pendences"
        class="btn btn-success rounded-pill ms-2"
        :class="{
          'btn-danger': pendencesFinancialManager > 0,
        }"
        title="Aprovações Pendentes (Ger. Financeira)"
      >
        <span v-if="isLoadingPendencesFinancialManager">
          <i class="ph-spinner spinner me-2" />
          Buscando Aprovações Pendentes (Ger. Financeira)
        </span>
        <span v-else>
          Aprovações Pendentes (Ger. Financeira)
          <span
            v-if="pendencesFinancialManager > 0"
            class="badge bg-primary ms-2"
          >
            {{ pendencesFinancialManager }}
          </span>
        </span>
      </router-link>
    </div>
  </div>
  <div class="row">
    <div v-for="(shortcut, index) in shortcuts" :key="index" class="col">
      <div class="card border-start border-start-width-2 border-start-primary">
        <div class="card-body text-center">
          <div
            class="d-flex flex-lg-row flex-column align-items-center justify-content-between"
          >
            <i :class="shortcut.icon" class="ph-3x text-primary" />
            <div>
              <h6 class="fw-light">{{ shortcut.title }}</h6>
              <router-link
                :to="shortcut.url"
                class="btn btn-success rounded-pill"
                title="Acessar"
              >
                Acessar
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AccessToDocs',

  data() {
    return {
      isLoadingPendencesManager: true,
      pendencesManager: 0,
      isLoadingPendencesFinancialManager: true,
      pendencesFinancialManager: 0,
      shortcuts: [
        {
          icon: 'ph-file',
          title: 'Contrato, Ordem de Compra, Ordem de Serviço',
          url: 'documents/contracts',
        },
        {
          icon: 'ph-file-dotted',
          title: 'Compras de pequeno vulto (processo simplificado)',
          url: 'documents/moviments',
        },
      ],
    }
  },

  computed: {
    ...mapGetters(['isManager', 'isFinancialManager']),
  },

  methods: {
    async getManagerPendences() {
      try {
        this.pendencesManager = await this.$store.dispatch(
          'getManagerPendences',
          {
            count: true,
          },
        )
        this.isLoadingPendencesManager = false
      } catch (error) {
        this.isLoadingPendencesManager = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getFinancialPendences() {
      try {
        this.pendencesFinancialManager = await this.$store.dispatch(
          'getFinancialPendences',
          {
            count: true,
          },
        )
        this.isLoadingPendencesFinancialManager = false
      } catch (error) {
        this.isLoadingPendencesFinancialManager = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    if (this.isManager) {
      this.getManagerPendences()
    }
    if (this.isFinancialManager) {
      this.getFinancialPendences()
    }
  },
}
</script>
